module.exports = __webpack_public_path__ + "static/media/CGV-WEISS-2020.6ad6c0b5.pdf";